import React from 'react';
import { useSelector } from 'react-redux';
import { LeadsContainer } from '../../plot/components/LeadsContainer';
import {
  rawSignalFrequencySelector,
  rawSignalLeadsSelector,
} from '../selectors/raw-signal.selectors';

interface Props {
  colorLeads?: boolean;
}

export const RawLeads: React.FC<Props> = ({ colorLeads = false }) => {
  const frequency = useSelector(rawSignalFrequencySelector);
  const leads = useSelector(rawSignalLeadsSelector);

  return (
    <LeadsContainer
      frequency={frequency}
      leadsData={leads}
      colorLeads={colorLeads}
    />
  );
};
